import { pushApiError } from '@/utils-v2/libs/sentry.js';

export const success = response => response.data;

export const failed = error => {
  pushApiError(error);

  throw error;
};
